import { Trans } from '@lingui/react'
import { Typography, Button, Box } from '@mui/material'
import { ProductPage2Query } from '../../graphql/ProductPage2.gql'

type ProductPageProductInfoProps = {
  product: NonNullable<NonNullable<NonNullable<ProductPage2Query['products']>['items']>[0]>
}

export function MoreOfThisBrand(props: ProductPageProductInfoProps) {
  const { product } = props

  const brandCat = product?.categories?.find((e) => e?.breadcrumbs?.[0]?.category_name === 'Merken')
  const brandCatUrl = brandCat?.url_path
  const brandCatName = brandCat?.name

  if (!brandCatUrl) return null

  return (
    <Box
      sx={(theme) => ({
        background: theme.palette.background.paper,
        paddingX: theme.spacings.md,
        display: 'flex',
        alignItems: 'center',
      })}
    >
      <Typography variant='h4'>
        <Trans id='View everything of:' />
      </Typography>
      <Button
        variant='text'
        size='small'
        color='primary'
        sx={(theme) => ({
          marginLeft: '1px',
          fontSize: theme.typography.h3,
          fontWeight: theme.typography.fontWeightLight,
        })}
        href={`/${brandCatUrl}`}
      >
        {brandCatName}
      </Button>
    </Box>
  )
}
